import { useEffect } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../redux/AppStore";
import { updateShipmentPostcode } from "../../redux/slice/UpdateTrackingAddressSlice";

export default function ShipmentPostcodeComponent () {
  const dispatch = useAppDispatch();
  const shipmentPostcode:string = useAppSelector((state: RootState) => state.updateAddress.newuserData.shipment_postcode);
    return (
        <div className="UpdateVerifyInput">
        <label>Postcode</label>
        <input type="text" className="form-control" placeholder="Postcode" value={shipmentPostcode} onChange={t =>  {
               dispatch(
                updateShipmentPostcode(t.target.value)
               )
            }
                }/>
      </div>
    );
}